import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://fr-xfinder.vercel.app"
  );
  console.log("API_BASE_URL:", API_BASE_URL)

export async function verifyAddress(addressData) {
  try {
    const shop =
      new URLSearchParams(window.location.search).get("shop") ||
      "victorgroups.myshopify.com";
    // Normalize address1 to remove commas and extra spaces
    const normalizedAddress = {
      ...addressData,
      address1: addressData.address1
        .replace(/,\s*/g, " ")
        .replace(/\s+/g, " ")
        .trim(),
      shop,
    };

    // Fetch or retrieve cached usage data
    let usage = { count: 0, remaining: null, isOverLimit: false };
    const cacheKey = `usage_${shop}`;
    const cacheTimeKey = `${cacheKey}_time`;
    const cached = localStorage.getItem(cacheKey);
    const cacheTime = localStorage.getItem(cacheTimeKey);
    const now = Date.now();

    if (cached && cacheTime && now - parseInt(cacheTime) < 300000) {
      console.log("Using cached usage data");
      try {
        usage = JSON.parse(cached);
      } catch (err) {
        console.warn("Invalid cached usage data, resetting:", err.message);
        localStorage.removeItem(cacheKey);
        localStorage.removeItem(cacheTimeKey);
      }
    } else {
      try {
        console.log("Fetching usage data from /plans");
        const usageResponse = await axios.get(`${API_BASE_URL}/plans`, {
          params: { shop },
        });
        usage = usageResponse.data.usage || usage;
        localStorage.setItem(cacheKey, JSON.stringify(usage));
        localStorage.setItem(cacheTimeKey, now.toString());
        console.log("Fetched usage:", usage);
      } catch (err) {
        console.warn("Failed to fetch usage data:", err.message, err.response?.data);
      }
    }

    // Preserve coordinates from previous validation
    let coordinates = null;
    const coordCacheKey = `coordinates_${shop}`;
    if (localStorage.getItem(coordCacheKey)) {
      try {
        coordinates = JSON.parse(localStorage.getItem(coordCacheKey));
      } catch (err) {
        console.warn("Invalid cached coordinates, resetting:", err.message);
        localStorage.removeItem(coordCacheKey);
      }
    }

    // Skip validation for suggested addresses, using cached usage
    if (normalizedAddress.isSuggested) {
      console.log("⚠️ Skipping validation - address was already suggested and validated");
      const result = {
        success: true,
        message: "Address already validated",
        data: {
          line1: normalizedAddress.address1,
          city: normalizedAddress.city,
          provinceOrState: normalizedAddress.province_code,
          postalCode: normalizedAddress.zip,
          country: normalizedAddress.country_code,
          formattedAddress: `${normalizedAddress.address1}, ${normalizedAddress.city}, ${normalizedAddress.province_code}, ${normalizedAddress.country_code}, ${normalizedAddress.zip}`,
          status: "valid",
          details: coordinates,
        },
        validationResult: {
          isValid: true,
          status: "valid",
          provider: "FRX-FINDER",
          warning: "", // Sanitized warning
          suggestedAddress: null,
          coordinates,
        },
        usage, // Use cached or fetched usage
      };
      console.log("🎯 Returning cached result:", result);
      return result;
    }

    // Validate user-entered addresses
    console.log("Sending verify-address request:", normalizedAddress);
    const response = await axios.post(
      `${API_BASE_URL}/verify-address`,
      normalizedAddress,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    const result = response.data;

    // Normalize backend response to include validationResult
    if (!result.validationResult) {
      result.validationResult = {
        isValid: result.data?.status === "valid" || result.data?.status === "corrected_hybrid",
        status: result.data?.status || "invalid",
        provider: "FRX-FINDER",
        warning: "", // Sanitized warning
        suggestedAddress: result.data?.suggestedAddress || null,
        coordinates: result.data?.details || null,
      };
    } else {
      result.validationResult.provider = "FRX-FINDER";
      result.validationResult.warning = ""; // Sanitize warning
    }

    // Cache coordinates
    if (result.validationResult.coordinates) {
      localStorage.setItem(coordCacheKey, JSON.stringify(result.validationResult.coordinates));
    }

    // Use backend's usage if available, otherwise fallback to fetched usage
    result.usage = result.usage || usage;

    console.log("Verify-address response:", result);
    return result;
  } catch (error) {
    console.error(
      "❌ Address verification error:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to verify address");
  }
}

export async function getAutocompleteSuggestions(shop, query) {
  try {
    console.log("Sending autocomplete request:", { shop, query });
    const response = await axios.get(`${API_BASE_URL}/autocomplete`, {
      params: { shop, query },
      headers: { "Content-Type": "application/json" },
    });
    console.log("Autocomplete response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Autocomplete error:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error || "Failed to fetch suggestions"
    );
  }
}

